export default "__VITE_ASSET__D6oA4mzz__"